module.exports = __webpack_public_path__ + "img/ma2.22245e3d.png";